export class GeocoderForwardResult {
    description: string = "";
    latitude: number = 0;
    longitude: number = 0;
}

